// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;My eyes will look down on my foes;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;my ears shall hear the ruin of the evildoers<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;who rise up against me.<br> </p> </div></div>";
// Exports
module.exports = code;